import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { applyWaveDistort } from "../engine/effects.js";

/**
 * WaveDistortNode
 * ---------------
 * Applies sine/cosine wave displacement to canvas pixels.
 */
export class WaveDistortNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Wave Distort";

    this.properties = {
      amplitude: 20,
      frequency: 0.02,
      phase: 0,
      direction: "horizontal",
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    this.addWidget("combo", "Direction", "horizontal", (val) => {
      this.properties.direction = val;
    }, { values: ["horizontal", "vertical", "both"] });

    addDrivableSlider(this, "Amplitude", "amplitude", 20, 0, 200, 1);
    addDrivableSlider(this, "Frequency", "frequency", 0.02, 0.001, 0.2, 0.001);
    addDrivableSlider(this, "Phase", "phase", 0, 0, 100, 0.1);

    finalizeDrivableSliders(this, 1);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 140];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    const { amplitude, frequency, phase, direction } = this.properties;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyWaveDistort(ctx, w, h, { amplitude, frequency, phase, direction });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/WaveDistort", WaveDistortNode);
